import React, { useState, useEffect } from 'react';

const hoje = () => new Date().toISOString().split('T')[0];

export default function EventModal({ isOpen, onClose, onSubmit, range }) {
  const [nome, setNome] = useState('');
  const [horaInicio, setHoraInicio] = useState('');
  const [horaFim, setHoraFim] = useState('');
  const [data, setData] = useState(hoje());

  // Quando o modal abre a partir de um clique no calendário, usa aquele dia;
  // se abriu pelo botão "Nova reserva", começa em hoje.
  useEffect(() => {
    if (!isOpen) return;
    setData(range?.start ? new Date(range.start).toISOString().split('T')[0] : hoje());
  }, [isOpen, range]);

  const limpar = () => { setNome(''); setHoraInicio(''); setHoraFim(''); };

  const handleSubmit = () => {
    if (!nome || !data || !horaInicio || !horaFim) {
      alert('Preencha nome, data e os horários.');
      return;
    }
    if (horaFim <= horaInicio) {
      alert('O horário de fim deve ser depois do início.');
      return;
    }
    onSubmit({ nome, inicio: `${data}T${horaInicio}`, fim: `${data}T${horaFim}` });
    limpar();
  };

  const handleClose = () => { limpar(); onClose(); };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onMouseDown={handleClose}>
      <div className="modal" onMouseDown={(e) => e.stopPropagation()}>
        <h3 className="modal__title">Nova reserva</h3>

        <div className="field">
          <label htmlFor="r-nome">Nome ou sala</label>
          <input id="r-nome" value={nome} onChange={e => setNome(e.target.value)} type="text" placeholder="Ex.: Reunião comercial" autoFocus />
        </div>

        <div className="field">
          <label htmlFor="r-data">Data</label>
          <input id="r-data" value={data} onChange={e => setData(e.target.value)} type="date" />
        </div>

        <div className="field">
          <label htmlFor="r-inicio">Início</label>
          <input id="r-inicio" value={horaInicio} onChange={e => setHoraInicio(e.target.value)} type="time" />
        </div>

        <div className="field">
          <label htmlFor="r-fim">Fim</label>
          <input id="r-fim" value={horaFim} onChange={e => setHoraFim(e.target.value)} type="time" />
        </div>

        <div className="modal__actions">
          <button className="btn btn--primary" onClick={handleSubmit}>Reservar</button>
          <button className="btn btn--ghost" onClick={handleClose}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}
